import React, {useState} from 'react';

export const IntroducirCodigoConfirmacion = (props) => {
	const {codigoConfirmacion, setCodigoConfirmacion, estadoRecuperarContraseña, comprobarCodigo} =
		props;

	return (
		<div className='ContentOlvContraseña'>
			<div className='fs-5 fw-semibold text-center'>¿Ha olvidado su contraseña?</div>
			<div className='centrador'>Introduzca el código que le llegó al correo:</div>
			<div className='inputCorreoOlvidarContraseña'>
				{estadoRecuperarContraseña === 4 && (
					<div className='centrador correroInvalido'>
						El código introducido es erróneo
					</div>
				)}
				<label htmlFor="" className='fw-bold'>Código de verificación:</label>
				<input
					type='text'
					placeholder='Codigo de confirmacion'
					className='text-dark form-control text-center'
					value={codigoConfirmacion}
					onChange={(e) => setCodigoConfirmacion(e.target.value)}
				/>
			</div>
			<div className=''>
				<button
					className='btn login-boton w-full'
					onClick={comprobarCodigo}
				>
					<b>Introducir código</b>
				</button>
			</div>
			<div className='centrador'>
				<div className='barraSeparadorContentBodyLoginInterno' />
			</div>
			<div className='centrador linkRestablecerContraseña'>
				<b> reenviar código</b>
			</div>
		</div>
	);
};
